import { Navigate, Route, Routes } from "react-router-dom";
import Login from "./components/Login/Login";
import Dashbord from "./components/Dashbord/Dashbord";
import PanelWeb from "./components/Web/Panel";
import RutaProtegida from "./components/Global/RutaProtegida";
import { ToastProvider } from "./components/Global/ToastContext";

export default function App() {
  return (
    <ToastProvider>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route
          path="/admin"
          element={
            <RutaProtegida>
              <Navigate to="/admin/dashboard" replace />
            </RutaProtegida>
          }
        />

        <Route
          path="/admin/dashboard"
          element={
            <RutaProtegida>
              <Dashbord />
            </RutaProtegida>
          }
        />

        <Route
          path="/admin/landing"
          element={
            <RutaProtegida>
              <Navigate to="/admin/landing/planes" replace />
            </RutaProtegida>
          }
        />

        <Route
          path="/admin/landing/:section"
          element={
            <RutaProtegida>
              <PanelWeb />
            </RutaProtegida>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </ToastProvider>
  );
}
